import { render, staticRenderFns } from "./TSREdit.vue?vue&type=template&id=7bf1c57a"
import script from "./TSREdit.vue?vue&type=script&lang=js"
export * from "./TSREdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports